import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ContactHoursComponent } from './contact-hours.component';
import { PlanDetailsPipeModule } from '../../../pipes/plan-detail-pipes.module';
import { TimeFormatPipe } from '../../../pipes/timeFormat.pipe';

@NgModule({
  declarations: [ContactHoursComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    DgxComponentsIconModule,
    PlanDetailsPipeModule,
  ],
  providers: [TimeFormatPipe],
  exports: [ContactHoursComponent],
})
export class ContactHoursComponentsModule {}
